import * as React from 'react';
import clsx from 'clsx';
import { ModalShell } from './ModalShell';

interface BottomDrawerProps {
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Slide-up bottom drawer for mobile actions. Renders via Portal; no backdrop
 * (parent handles dismissal). Composes `ModalShell` with the `bottom-drawer`
 * variant for the animation + portal plumbing.
 */
export const BottomDrawer: React.FC<BottomDrawerProps> = ({ isOpen, children, className }) => (
  <ModalShell
    isOpen={isOpen}
    position='bottom-drawer'
    portal
    bodyClassName={clsx(
      'w-full bg-white',
      'rounded-t-20 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]',
      'p-6',
      className
    )}
  >
    {children}
  </ModalShell>
);

export default BottomDrawer;
